import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { DevBar } from "@/app/components/DevBar";
import { OfflineBanner } from "@/app/components/OfflineBanner";
import type { AuthStatus } from "@/shared/auth";

export interface RouterContext {
  auth: { status: AuthStatus };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    /**
     * `pt-safe` LIVES HERE, on the frame every screen renders inside, and nowhere else.
     *
     * It used to live on the dev bar — which returns null when the environment is
     * production. So dev and staging cleared the notch and the App Store build rendered its
     * headings under the status bar, on exactly the identity nobody can hot-fix. The native
     * config also disables the web view's own inset, on the stated premise that the web
     * content owns its safe areas; this is the web content owning them.
     */
    <div className="pt-safe flex min-h-dvh flex-col bg-background text-foreground">
      <DevBar />
      <OfflineBanner />
      <Outlet />
    </div>
  );
}
